// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__32mmy","buttons":"RemoveExpirationActionButtons_buttons__2qyI3"};